import script from "./supplier-form.vue?vue&type=script&setup=true&lang=js"
export * from "./supplier-form.vue?vue&type=script&setup=true&lang=js"

import "./supplier-form.vue?vue&type=style&index=0&id=7fa1ba9a&lang=css"

const __exports__ = script;

export default __exports__